import React from 'react'
import styles from './billing.module.scss'

export default ({ changeBilling, currentBilling }) => (
  <div className={styles.billing}>
    <p className={styles.billing__text}>biilling</p>

    <div className={styles.billing__btns}>
      <button
        className={currentBilling === 'monthly' ? 'active' : ''}
        onClick={() => changeBilling('monthly')}
      >
        <strong>monthly</strong>
      </button>
      <button
        className={currentBilling === 'yearly' ? 'active' : ''}
        onClick={() => changeBilling('yearly')}
      >
        <strong>Yearly</strong> (save 20%)
      </button>
    </div>
  </div>
)
